import React from 'react'
const BAR_COUNT = 12

function BarChartSkeleton() {
    return (
        <div style={{ width: '100%', position: 'relative', height: '100%' }}>
            <div
                className="w-full h-full flex flex-col items-center justify-center"
                style={{
                    maxHeight: 270,
                    height: 270,
                    position: 'relative',
                }}
            >
                {/* Vertical bars */}
                <div
                    className="classroom-barchart-grid"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        zIndex: 3,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'flex-end',
                    }}
                >
                    {Array.from({ length: BAR_COUNT }).map((_, idx) => {
                        // between 60–180
                        const height = 60 + ((idx * 37) % 120)

                        return (
                            <div
                                key={idx}
                                style={{
                                    flex: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    padding: '0 4px',
                                }}
                            >
                                <div
                                    className="animate-pulse"
                                    style={{
                                        width: '85%',
                                        height: `${height}px`,
                                        borderRadius: 6,
                                        background: '#ECEBF8',
                                        marginBottom: 8,
                                    }}
                                />
                            </div>
                        )
                    })}
                </div>
            </div>
            {/* Labels */}
            <div
                className="classroom-barchart-grid"
                style={{
                    marginTop: 7,
                    display: 'flex',
                    flexDirection: 'row',
                    flex: 1,
                }}
            >
                {Array.from({ length: BAR_COUNT }).map((_, idx) => (
                    <div
                        key={idx}
                        style={{
                            flex: 1,
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <div
                            className="animate-pulse"
                            style={{
                                width: 24,
                                height: 24,
                                borderRadius: 16,
                                background: '#ECEBF8',
                                marginBottom: 6,
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default BarChartSkeleton
